import { Provider } from "react-redux";
import React from "react";
import store from "../stores/reduxStore";

import { Router, Route } from "react-router-dom";
import browserHistory from "../helpers/history";
import NounProjectNavigation from "../components/nounproject-navigation";

class NounProjectNavigationParent extends React.Component {
    render() {
        // this component exists to pass the redux store to the legacy iconlist component
        return (
            <Provider store={store}>
                <Router history={browserHistory}>
                    <Route
                        component={routerProps => (
                            <NounProjectNavigation
                                {...this.props}
                                {...routerProps}
                            />
                        )}
                    />
                </Router>
            </Provider>
        );
    }
}

export default NounProjectNavigationParent;
